export const GOOGLE_API_KEY = "AIzaSyClmqhNt_u2oKH5FJPgEEzFmswp9IuVVE0";